import { apiService, AccountDto, UpdateAccountDto } from './api';

export class AccountService {
  /**
   * Get account profile information
   */
  async getProfile(token: string): Promise<AccountDto> {
    return apiService.getAccountProfile(token);
  }

  /**
   * Update account profile information
   */
  async updateProfile(token: string, accountData: UpdateAccountDto): Promise<void> {
    return apiService.updateAccountProfile(token, accountData);
  }

  /**
   * Delete account permanently
   */
  async deleteAccount(token: string): Promise<void> {
    return apiService.deleteAccount(token);
  }

  /**
   * Unsubscribe from email notifications
   */
  async unsubscribe(token: string): Promise<{ message: string }> {
    return apiService.unsubscribeUser(token);
  }
}

export const accountService = new AccountService();